<template>
    <section v-if="jobs?.length" class="container mt-12">
        <h2 class="mb-6 text-2xl font-bold text-gray-900 dark:text-txt-headings sm:text-3xl">Ďalšie ponuky od {{ orgTitle }}</h2>
        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <NuxtLink
                v-for="job in jobs"
                :key="job.id"
                :to="`/praca/${job.slug || job.id}`"
                class="flex flex-col gap-1 rounded-2xl border border-gray-200 dark:border-default bg-white dark:bg-surface-card p-5 transition hover:border-orange-300 hover:shadow-md"
            >
                <span class="text-lg font-semibold leading-tight text-gray-900 dark:text-txt-headings">{{ job.title }}</span>
                <span class="text-sm text-gray-600 dark:text-txt-body">
                    {{ [formatJobPlaceShort(job), formatJobSalaryShort(job)].filter(Boolean).join(' · ') }}
                </span>
                <span class="mt-2 text-sm font-semibold text-[#f97316]">Pozrieť ponuku →</span>
            </NuxtLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { Job } from '#shared/types/Job'
import { formatJobPlaceShort, formatJobSalaryShort } from '@/utils/jobCardText'

interface Props {
    orgId: string
    orgTitle: string
    /** The job currently shown, left out of the list. */
    excludeId: string
}

const props = defineProps<Props>()

type OrgJob = Pick<Job, 'id' | 'slug' | 'title' | 'jobPlace' | 'jobLocation' | 'salaryMin' | 'salaryMax' | 'salaryUnit'>

const { data: jobs } = await useFetch<OrgJob[]>('/api/jobs/by-org', {
    key: `org-other-jobs-${props.orgId}-${props.excludeId}`,
    query: { orgId: props.orgId, exclude: props.excludeId }
})
</script>
